import { Drawer as DrawerComponent } from "./Drawer";
import { Connections } from "./connections/Connections";
import { SelectableGrid } from "./SelectableGrid";

export const Drawer = Object.assign(DrawerComponent, {
  Connections,
  SelectableGrid,
});

export type { DrawerProps, DrawerHeaderProps } from "./Drawer";
